export const ONE_KILOBYTE = 1024;
export const ONE_MEGABYTE = ONE_KILOBYTE * 1024;
export var FileType;
(function (FileType) {
    FileType["csv"] = "text/csv";
    FileType["doc"] = "application/msword";
    FileType["docx"] = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    FileType["xls"] = "application/vnd.ms-excel";
    FileType["xlsx"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    FileType["pdf"] = "application/pdf";
    FileType["json"] = "application/json";
    FileType["jpeg"] = "image/jpeg";
    FileType["png"] = "image/png";
    FileType["zip"] = "application/zip";
    FileType["mp4"] = "video/mp4";
    FileType["audio"] = "audio/mpeg";
})(FileType || (FileType = {}));
export const filePickerFileTypes = {
    csv: {
        [FileType.csv]: ['.csv'],
    },
    doc: {
        [FileType.doc]: ['.doc'],
    },
    docx: {
        [FileType.docx]: ['.docx'],
    },
    xls: {
        [FileType.xls]: ['.xls'],
    },
    xlsx: {
        [FileType.xlsx]: ['.xlsx'],
    },
    pdf: {
        [FileType.pdf]: ['.pdf'],
    },
    jpeg: {
        [FileType.jpeg]: ['.jpeg', '.jpg'],
    },
    png: {
        [FileType.png]: ['.png'],
    },
    zip: {
        [FileType.zip]: ['.zip'],
    },
    mp4: {
        [FileType.mp4]: ['.mp4'],
    },
    audio: {
        [FileType.audio]: ['.mpeg'],
    },
};
//# sourceMappingURL=file.js.map